export const fetchWalletBalance = async (walletAddress: string) => {
  const response = await fetch(
    `https://toncenter.com/api/v2/getAddressBalance?address=${walletAddress}`,
  )
  const data = (await response.json()) as {
    ok: boolean
    result: string
  }
  return Number.parseFloat(data.result) / 1e9
}
